import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { CourseStateType } from 'enum/course-state.enum'
import { courseStateVisuals } from './courseStateVisuals'
import { State } from './styled'

interface CourseStateBadgeProps {
  state: CourseStateType | number
}

export const CourseStateBadge = ({ state }: CourseStateBadgeProps) => {
  const { t } = useTranslation()
  const numericState = Number(state) as CourseStateType
  const entry = courseStateVisuals.find((item) => item.id === numericState)
  const translateKey = CourseStateType[numericState]

  if (!entry || translateKey === undefined) {
    return <>--</>
  }

  return (
    <State color={entry.color} height={32}>
      <FontAwesomeIcon icon={entry.icon} />
      {t(`commons.course.state.${translateKey}`)}
    </State>
  )
}
